import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SHCardPriceView from './SHCardPriceView';
import { shortImageSize } from '../../../../../utils/utils';
import px2dp, { px2dpSmall, aiDp, pxdp } from '../../../../../utils/px2dp';
import {
  getColorSchemeStyle,
  DynamicColorValue,
} from '../../ColorSchemeV2/index';
import utils from '../../../../../utils/utils';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

const NumberOrText = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

// Web 版 A8 扁平商品卡，实现与 RN 版尽量一致的逻辑
const isAndroid = utils.isAndroid();
const shihuo = typeof window !== 'undefined' && window.shihuo;
const screen = typeof window !== 'undefined' && window.screen;
const innerWidth = typeof window !== 'undefined' && window.innerWidth;
const innerHeight = typeof window !== 'undefined' && window.innerHeight;

const vCardWidth =
  typeof window !== 'undefined' &&
  (innerWidth - px2dpSmall(12) * 2 - px2dpSmall(9)) / 2;
const kCharacter = ' | ';

const baseStyle = {
  containerMarginTop: px2dp(18),
  imgMarginTop: px2dp(10),
  bottomWordsHeight: px2dp(36),
  bottomWordsWidth: vCardWidth,
  bottomTagsHeight: px2dp(28),
  bottomTagsMarginTop: px2dp(10),
  bottomTagsMarginBottom: px2dp(32),
  bottomTagsWidth: px2dp(302),
  bottomTagsRankMarginBottom: px2dp(4),
  nameMarginTop: px2dp(8),
};

let styles = pageStyles;

function getImgHeight(item, cardWidth) {
  const { img_w, img_h } = item;
  const cw = cardWidth || 180;
  let imgWidth = cw * 2;
  let imgHeight = imgWidth;
  if (img_w && img_h && +img_w > 0 && +img_h > 0) {
    imgHeight = imgWidth * (+img_h / +img_w);
  }
  return imgHeight;
}

function calculateWords(name, spec_name) {
  const sh_scale_factor = innerWidth / 375;
  let maxWordLength = Math.floor(40 * sh_scale_factor);
  let blackWord = '...';
  let blankLength = getByteCount(blackWord);
  let kCharacterLength = getByteCount(kCharacter);
  let desc = name;
  if (spec_name && spec_name.length > 0) {
    let nameLength = getByteCount(name);
    let specLength = getByteCount(kCharacter + spec_name);
    let currentMaxLength = nameLength + kCharacterLength + specLength;
    if (currentMaxLength <= maxWordLength) {
      desc = name + kCharacter + spec_name;
    } else {
      let cNameLength =
        maxWordLength - specLength - blankLength - kCharacterLength < 0
          ? 0
          : maxWordLength - specLength - blankLength - kCharacterLength;
      if (nameLength > maxWordLength && specLength > maxWordLength) {
        desc = handleName(name, 18) + blackWord + kCharacter + handleName(spec_name, 22);
      } else if (nameLength > maxWordLength) {
        // 会出现相加的结果还是展示不下,则给name多截取一个字段
        const subStringCName = cNameLength > 1 ? cNameLength - 1 : cNameLength
        desc = handleName(name, subStringCName) + blackWord + kCharacter + spec_name;
      } else if (specLength > maxWordLength) {
        desc = handleName(name, cNameLength) + blackWord + kCharacter + handleName(spec_name, maxWordLength);
      } else {
        desc = handleName(name, cNameLength) + blackWord + kCharacter + spec_name;
      }
    }
  }
  return desc;
}

function getTags(dataSource) {
    const { labels = [], v_datas = [] } = dataSource;
    let bottomTagList = [];
    let totalWidth = 0;

    for (let i in labels) {
        const item = labels[i];
        let activityImageWidth = 0.0;
        if (item.type == 'ACTIVITY') {
            if (item.activity_img && item.activity_img.length > 0) {
                if (item.activity_img_ratio && parseFloat(item.activity_img_ratio) > 0) {
                    activityImageWidth = baseStyle.bottomTagsHeight * parseFloat(item.activity_img_ratio);
                } else {
                    continue
                }
            }
        }
        totalWidth += px2dp(8) + (getByteCount(item.text) * px2dp(10) + px2dp(8)) + activityImageWidth;
        if (totalWidth <= baseStyle.bottomTagsWidth) {
            bottomTagList.push(item);
        }
    }
    const label_types = bottomTagList
        .map((it, index) => {
            return it.type || '';
        })
        .join(',');
    const label_text = bottomTagList
        .map((it, index) => {
            return it.text || '';
        })
        .join(',');

    let rec_word_types = '';
    let rec_word_text = '';
    let wordsData = {};
    const vDatas0 = v_datas && v_datas != null && v_datas.length > 0 ? v_datas[0] : {};
    let item_datas = vDatas0.item_datas && vDatas0.item_datas != null && vDatas0.item_datas.length > 0 ? vDatas0.item_datas : [];
    if (v_datas && v_datas != null && v_datas.length > 0) {
        if (item_datas && item_datas != null && item_datas.length > 0) {
            wordsData = item_datas[0];
            rec_word_types = vDatas0.type || '';
            rec_word_text = wordsData.text || '';
        }
    }
    return { label_types, label_text, rec_word_text, rec_word_types };
}

function getContainerHeight(item, cardWidth = vCardWidth) {
    const {
        formatN = '',
        style_img_list = [],
        spec_name,
        benefits,
        name,
        attrLabels,
        labels,
        v_datas = [],
        isBlackBgImg,
        cateType,
        whiteBgImgFlag,
        beltImg,
        nameLineBreak = false
    } = item;
    const imgHeight = getImgHeight(item, cardWidth);
    // 图片背景图上间距
    // const imgMarginTop = parseInt(cateType) == 3 && parseInt(whiteBgImgFlag) == 1 ? baseStyle.imgMarginTop : 0;
    // let containerHeight = imgMarginTop + px2dp(imgHeight);
    let containerHeight = imgHeight / 2;

    // 文字上间距是否置空
    let nameTopHasData = false;

    if (formatN && parseInt(formatN) == 3) {
        if (style_img_list && style_img_list.length > 0) {
            const { formatNType = 0 } = style_img_list[0];
            if (formatNType == 2) {
                // 口红一行3
                containerHeight += px2dp(90 + 8);
                nameTopHasData = true;
            } else if (formatNType == 3) {
                containerHeight += px2dp(88 + 8);
                nameTopHasData = true;
            } else {
                // 一行3
                containerHeight += px2dp(88 + 8);
                nameTopHasData = true;
            }
        }
    } else if (formatN && parseInt(formatN) == 5 && style_img_list && style_img_list.length > 0) {
        // 一行5
        containerHeight += px2dp(56 + 8);
        nameTopHasData = true;
    }

    // 是否有腰带
    if (beltImg && beltImg.length > 0) {
        nameTopHasData = true;
    }

    if (whiteBgImgFlag == false) {
        nameTopHasData = true;
    }

    // 标题高度
    let desc = calculateWords(name, spec_name);
    const nameLength = getByteCount(desc);
    if (nameLength > 22 && nameLineBreak) {
        containerHeight += px2dp(40) * 2 + px2dp(8);
    } else {
        containerHeight += px2dp(40) + px2dp(8);
    }

    // 文字顶部只是白底图则减少文字上边距
    // if (nameTopHasData == false) {
    //     containerHeight -= baseStyle.nameMarginTop;
    // }

    // 标签高度
    // if (getSplitAttributeTagStr(attrLabels).length > 0) {
    //     containerHeight += px2dp(36);
    // }
    //价格距离上边模块2
    containerHeight += aiDp(2);
    // 价格高度
    containerHeight += px2dp(50);

    if (v_datas && v_datas != null && v_datas.length > 0) {
        containerHeight += aiDp(1)
        containerHeight += baseStyle.bottomWordsHeight;
    } else if (labels && labels.length > 0) { // 标签高度
        let tags = [];
        for (let i in labels) {
            const item = labels[i];
            if (item.type == 'ACTIVITY') {
                if (item.activity_img && item.activity_img.length > 0) {
                    if (item.activity_img_ratio && parseFloat(item.activity_img_ratio) > 0) {
                    } else {
                        continue
                    }
                }
            }
            tags.push(item);
        }
        if (tags.length > 0) {
            containerHeight += aiDp(1)
            containerHeight += baseStyle.bottomWordsHeight;
        }
    }

    // 最底部间距
    containerHeight += aiDp(4);

    return containerHeight;
}

function getWidgetHeight(item, widgetWidth) {
  return getContainerHeight(item, widgetWidth) + baseStyle.containerMarginTop;
}

function getByteCount(str) {
  if (!str || !str.length) {
    return 0;
  }
  let count = 0;
  for (let i = 0; i < str.length; i++) {
    const c = str.charAt(i);
    if (c === '1') {
      count += 0.46;
    } else if (c === '.') {
      count += 0.29;
    } else if (c === ' ') {
      count += 0.25;
    } else if (/^[\u0000-\u00ff]$/.test(c)) {
      count += 1
    } else {
      count += 2;
    }
  }
  return count;
}

function handleName(str, num) {
  let count = 0;
  let i = 0;
  for (; i < str.length; i++) {
    const c = str.charAt(i);
    if (c === '1') {
      count += 0.46;
    } else if (c === '.') {
      count += 0.29;
    } else if (c === ' ') {
      count += 0.5;
    } else if (/^[\u0000-\u00ff]$/.test(c)) {
      if (/[A-Z]/.test(c)) {
        count += 1.2;
      } else {
        count += 1;
      }
    } else {
      count += 2;
    }
    if (count > num) {
      break;
    }
  }
  return str.substring(0, i);
}

function getStyle3Imgs(style_imgs = [], item) {
    // 截取四个配色，第一个配色作为主图（大图），剩下三个作为配色图
    let result = style_imgs.slice(0, 4);
    // 一个配色都没有是异常情况
    if (result.length == 0) {
        result.push({ ...item });
    }
    return result;
}

function getStyleImgs(style_imgs = [], item) {
    // 截取5个配色，第一个配色作为主图（大图），剩下三个作为配色图
    let result = style_imgs.slice(0, 6);
    if (result.length == 0) {
        result.push({ ...item });
    }
    return result;
}

function getSplitAttributeTagStr(attributeList) {
    let attributeModelList = attributeList;
    // 如果数组是空则返回空字符
    if (!attributeModelList || attributeModelList.length === 0) {
        return '';
    }
    var attributeTagStr = '';
    for (var i = 0; i < 3; i++) {
        let item = attributeModelList[i];
        if (item) {
            attributeTagStr = attributeTagStr + item + ' | ';
        }
    }
    var attributeTagStr2 = attributeTagStr.substring(0, attributeTagStr.length - 3);
    let count = attributeTagStr2.split(' | ').length;
    var lastAttributeTagStr = attributeTagStr2;
    switch (count) {
        case 1:
            lastAttributeTagStr = attributeTagStr2.substring(0, 14);
            break;
        case 2:
            lastAttributeTagStr = attributeTagStr2.substring(0, 16);
            break;
        case 3:
            lastAttributeTagStr = attributeTagStr2.substring(0, 18);
            break;
        default:
            break;
    }
    return lastAttributeTagStr;
}

class GoodsImage extends Component {
  constructor(props) {
    super(props);
    this.state = { imgVisible: true };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      JSON.stringify(this.state) != JSON.stringify(nextState) ||
      JSON.stringify(this.props) != JSON.stringify(nextProps)
    );
  }

  setImgVisible = (imgVisible) => {
    this.setState({ imgVisible });
  };

  render() {
    const {
      styles,
      img,
      imgHeight,
      beltImg,
      beltFrameImg,
      isBlackBgImg,
      cateType,
      whiteBgImgFlag,
      goodsImgFadeDuration = -1,
      img_w = '',
      img_h = '',
    } = this.props;
    const { imgVisible } = this.state;

    const isRatio5_4 = parseFloat(img_w) / parseFloat(img_h) == 5.0 / 4.0;
    const defaultStyle = !(parseInt(cateType) != 3 || isBlackBgImg == 1);

    const containerStyle = {
      width: '100%',
      height: imgHeight / 2,
      overflow: 'hidden'
    };

    const imgStyle = defaultStyle
      ? styles.img
      : (
        isRatio5_4
          ? styles.ratio5_4Img
          : styles.blackImg
      );

    return (
      <div style={containerStyle}>
        <LazyLoadImage
          key={this.props.key}
          style={{
            ...imgStyle,
            display: 'block'
          }}
          src={imgVisible ? shortImageSize(img, imgHeight) : ''}
          effect="opacity"
          wrapperProps={{
            style: {
              transitionDuration: '700ms',
            },
          }}
        />
        {beltFrameImg ? (
          <img
            style={styles.beltFrameImg}
            src={shortImageSize(beltFrameImg)}
            alt="belt-frame"
          />
        ) : null}
        {beltImg ? (
          <img
            style={styles.blackBeltImg}
            src={shortImageSize(beltImg)}
            alt="belt"
          />
        ) : null}
      </div>
    );
  }
}

// 一拖 3：图片 + 文本
class GoodsStyle3ImageView extends Component {
  constructor(props) {
    super(props);
    this.state = { imgVisible: true };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      JSON.stringify(this.state) != JSON.stringify(nextState) ||
      JSON.stringify(this.props) != JSON.stringify(nextProps)
    );
  }

  setImgVisible = (imgVisible) => {
    this.setState({ imgVisible });
  };

  render() {
    const { styles, showingStyleImgs, cardWidth } = this.props;
    const { imgVisible } = this.state;

    return (
      <div style={styles.goodsCardSku3ImgTextView}>
        {showingStyleImgs.map((item, index) => {
          const { name = '', img = '', newProductIcon = '' } = item;
          const text = handleName(name, 8);

          return (
            <div
              key={`sku_${index}`}
              style={{
                ...styles.goodsCardSkuBorder3,
                marginHorizontal: index === 1 ? (cardWidth - px2dp(88 * 3) - px2dp(48)) / 2 : 0
              }}
            >
              <img
                style={styles.goodsCardSkuImgT}
                src={imgVisible ? shortImageSize(img, 88) : ''}
                alt="style"
              />
              <p
                style={{
                  ...styles.goodsCardSkuImgText,
                  lineClamp: 1
                }}
              >
                {text}
              </p>
              {newProductIcon && newProductIcon.length > 0 ? (
                <img
                  style={styles.goodsCardSkuLogoImage}
                  src={newProductIcon}
                  alt="new"
                />
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }
}

// 一拖 3：色块 + 文本
class GoodsStyle3View extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      JSON.stringify(this.state) != JSON.stringify(nextState) ||
      JSON.stringify(this.props) != JSON.stringify(nextProps)
    );
  }

  render() {
    const { styles, showingStyleImgs, cardWidth } = this.props;
    return (
      <div style={styles.goodsCardSku3View}>
        {showingStyleImgs.map((item, index) => {
          const { name = '', color_hex = '', newProductIcon = '' } = item;
          return (
            <div
              key={`sku_${index}`}
              style={{
                ...styles.goodsCardSkuBorderV3,
                marginHorizontal: index === 1 ? (cardWidth - px2dp(88 * 3) - px2dp(48)) / 2 : 0
              }}
            >
              <div
                style={{
                  ...styles.goodsCardSkuColor,
                  backgroundColor: color_hex,
                }}
              />
              <p
                style={styles.goodsCardSkuText}
              >
                {name}
              </p>
              {newProductIcon && newProductIcon.length > 0 ? (
                <img
                  style={styles.goodsCardSkuLogoImage}
                  src={newProductIcon}
                  alt="new"
                />
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }
}

// 一拖 3：纯图片
class GoodsStyle3Image extends Component {
  constructor(props) {
    super(props);
    this.state = { imgVisible: true };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      JSON.stringify(this.state) != JSON.stringify(nextState) ||
      JSON.stringify(this.props) != JSON.stringify(nextProps)
    );
  }

  setImgVisible = (imgVisible) => {
    this.setState({ imgVisible });
  };

  render() {
    const { styles, showingStyleList, cardWidth } = this.props;
    const { imgVisible } = this.state;

    return (
      <div style={styles.goodsCardSku3}>
        {showingStyleList.map((item, index) => {
          const { img = '', newProductIcon = '' } = item;
          return (
            <div
              key={`sku_${index}`}
              style={{
                ...styles.goodsCardSkuBorder3,
                marginHorizontal: index === 1 ? (cardWidth - px2dp(88 * 3) - px2dp(48)) / 2 : 0
              }}
            >
              <img
                style={styles.goodsCardSkuImage3}
                src={imgVisible ? shortImageSize(img, 88) : ''}
                alt="style"
              />
              {newProductIcon && newProductIcon.length > 0 ? (
                <img
                  style={styles.goodsCardSkuLogoImage}
                  src={newProductIcon}
                  alt="new"
                />
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }
}

// 一拖 5：小图
class GoodsStyleImage extends Component {
  constructor(props) {
    super(props);
    this.state = { imgVisible: true };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      JSON.stringify(this.state) != JSON.stringify(nextState) ||
      JSON.stringify(this.props) != JSON.stringify(nextProps)
    );
  }

  setImgVisible = (imgVisible) => {
    this.setState({ imgVisible });
  };

  render() {
    const { styles, showingStyleImgs, onStyleItemPress, cardWidth } = this.props;
    const { imgVisible } = this.state;

    const gap = (cardWidth - 56 * 5 - (32 + 16)) / 4;

    return (
      <div style={styles.goodsCardSku}>
        {showingStyleImgs.map((item, index) => {
          const { img = '' } = item;
          const itemStyle = {
            overflow: 'hidden',
            width: 56,
            height: 56,
            border: '1px solid #f1f1f1',
            borderRadius: 4,
            marginLeft: index === 0 ? 0 : gap,
            boxSizing: 'border-box',
          };

          return (
            <div
              key={`sku_${index}`}
              style={{
                ...styles.goodsCardSkuBorder,
                marginHorizontal: (index === 1 || index === 2 || index === 3) ? ((cardWidth - px2dp(56 * 5) - px2dp(32 + 16)) / 4) : 0,
              }}
            >
              <img
                style={styles.goodsCardSkuImage}
                src={imgVisible ? shortImageSize(img, 56) : ''}
                alt="style"
              />
            </div>
          );
        })}
      </div>
    );
  }
}

class SHGoodsCommonVertFlatStyle8Widget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      priceViewWidth: 0,
      infoViewWidth: 0,
      hotViewWidth: 0,
      parentWidth: 0,
    };
    this.cardWidth = props.cardWidth || vCardWidth;
  }

  static propTypes = {
    dataSource: PropTypes.shape({
      labels: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string, //标签类型，取值范围如下，活动标签:ACTIVITY, 描述:DESC, 折扣:DISCOUNT, 入选排行榜:HOTLIST
          text_list: PropTypes.arrayOf(PropTypes.string), //标签内容列表
          text: PropTypes.string, //标签内容
          tcolor: PropTypes.string, //标签文字颜色
          bgcolor: PropTypes.string, //标签背景颜色
          bcolor: PropTypes.string, //标签边框颜色
          activity_img: PropTypes.string, // 标签图片链接
          activity_img_ratio: PropTypes.string, // 标签图片比例
        })
      ),
      salestyle: NumberOrText, //2为显示折扣，3为显示原价
      img: PropTypes.string, //商品图
      goods_color_num: NumberOrText, //商品配色数目
      model_count: NumberOrText, //商品型号数目
      isBlackBgImg: NumberOrText, // 0:白底图  1:黑底图
      whiteBgImgFlag: NumberOrText, // 1:白底图 0:黑底图
      // isCommonCate: NumberOrText, // 1通用类目 0:非通用
      cateType: NumberOrText, // 3: 通用 1: 服 2: 鞋
      name: PropTypes.string, //商品名称
      sales_info_text: NumberOrText, //销量、热度文案
      sales_info_num: NumberOrText, //销量、热度数值
      official_price: NumberOrText, //原价、官方价
      price: NumberOrText, //价格
      discount: NumberOrText, //原价、官方价
      actCornerImg: PropTypes.string, //左上角角标
      img_w: PropTypes.string, //图片宽比
      img_h: PropTypes.string, //图片高比
      benefits: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string, //利益点标签类型
          text: PropTypes.string, //利益点标签内容
          text_list: PropTypes.arrayOf(PropTypes.string), //利益点标签内容列表
          amount: NumberOrText, //利益点标签金额
          tcolor: PropTypes.string, //利益点标签文字颜色
          bgcolor: PropTypes.string, //利益点标签背景颜色
          bcolor: PropTypes.string, //利益点标签边框颜色
        })
      ),
      spec_name: NumberOrText, // SUK描述
      attrLabels: PropTypes.arrayOf(PropTypes.string), //商品属性标签内容列表
      formatN: PropTypes.string, // 一拖n    3 一拖3    5 一拖5
      style_imgs: PropTypes.arrayOf(PropTypes.string), //商品小款式图
      style_img_list: PropTypes.arrayOf(
        PropTypes.shape({
          style_id: PropTypes.string,
          name: PropTypes.string,
          newProductIcon: PropTypes.string,
          color_hex: PropTypes.string,
          formatNType: NumberOrText,
          img: PropTypes.string,
        })
      ),
    }),
    onPress: PropTypes.func,
    onStyleItemPress: PropTypes.func,
    onDataItemPress: PropTypes.func,
    isDark: PropTypes.bool,
  };

  static defaultProps = {
    dataSource: {
      labels: [],
      img: '',
      goods_color_num: 0,
      model_count: 0,
      isBlackBgImg: 0,
      whiteBgImgFlag: 0,
      cateType: 1,
      name: '',
      sales_info_text: '',
      price: '',
      discount: '',
      formatN: '',
      style_img_list: [],
      benefits: [],
      spec_name: '',
      attrLabels: [],
      salestyle: '',
      sales_info_num: '',
      official_price: '',
      actCornerImg: '',
      img_w: '',
      img_h: '',
    },
    onPress: () => {},
    onStyleItemPress: () => {},
    onDataItemPress: () => {},
    isDark: false,
  };

  componentDidMount() {
    this._updatePriceViewWidth();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.parentWidth) {
      this._updateParentWidth();
    }
    if (!prevState.priceViewWidth) {
      this._updatePriceViewWidth();
    }
    if (!prevState.infoViewWidth) {
      this._updateInfoViewWidth();
    }
    if (!prevState.hotViewWidth) {
      this._updateHotViewWidth();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(this.state) != JSON.stringify(nextState)) {
      return true;
    }
    if (JSON.stringify(this.props) != JSON.stringify(nextProps)) {
      return true;
    }
    return false;
  }

  setImgVisible = (imgVisible) => {
    this.goodsImgRef && this.goodsImgRef.setImgVisible(imgVisible);
    this.goodsStyleImgRef && this.goodsStyleImgRef.setImgVisible(imgVisible);
  };

  // 在 DOM 渲染完成后，测量价格信息父容器的可见宽度
  _updateParentWidth = () => {
    if (!this.bottomRef || !this.bottomRef.getBoundingClientRect) {
      return;
    }
    const rect = this.bottomRef.getBoundingClientRect();
    const width = rect && rect.width ? rect.width : 0;
    this.setState({ parentWidth: width });
  };

  // 在 DOM 渲染完成后，测量价格区域的可见宽度
  _updatePriceViewWidth = () => {
    if (!this.priceViewRef || !this.priceViewRef.getBoundingClientRect) {
      return;
    }
    const rect = this.priceViewRef.getBoundingClientRect();
    const width = rect && rect.width ? rect.width : 0;
    this.setState({ priceViewWidth: width });
  };

  // 在 DOM 渲染完成后，测量信息区域的可见宽度
  _updateInfoViewWidth = () => {
    if (!this.infoViewRef || !this.infoViewRef.getBoundingClientRect) {
      return;
    }
    const rect = this.infoViewRef.getBoundingClientRect();
    const width = rect && rect.width ? rect.width : 0;
    this.setState({ infoViewWidth: width });
  };

  // 在 DOM 渲染完成后，测量热度区域的可见宽度
  _updateHotViewWidth = () => {
    if (!this.hotViewRef || !this.hotViewRef.getBoundingClientRect) {
      return;
    }
    const rect = this.hotViewRef.getBoundingClientRect();
    const width = rect && rect.width ? rect.width : 0;
    this.setState({ hotViewWidth: width });
  };

  render() {
    const {
      goodsImgFadeDuration = -1, // 保留以兼容调用方，实际 web 版不使用
      dataSource = {},
      onPress = () => {},
      onStyleItemPress = () => {},
      onDataItemPress = () => {},
      isDark = false,
      h5_exposure_object = {},
    } = this.props;

    styles = getColorSchemeStyle(pageStyles, isDark);

    const {
      labels = [],
      img,
      goods_color_num,
      model_count,
      isBlackBgImg,
      whiteBgImgFlag,
      cateType,
      name,
      sales_info_text = '',
      sales_info_num = '',
      price = '--',
      discount,
      formatN = '',
      img_w = '',
      img_h = '',
      style_img_list = [],
      benefits = [],
      attrLabels,
      salestyle,
      official_price,
      actCornerImg,
      beltImg = null,
      beltFrameImg = null,
      spec_name = '',
      v_datas = [],
      nameLineBreak = false,
      promotion_icon = {},
      price_datas = [],
      fontSizeExp = false
    } = dataSource;

    const {
      ratio: activity_ratio = 1,
      icon: activity_icon = '',
    } = promotion_icon;

    let tag = {
      text: discount,
      tcolor: '#999999',
      bcolor: '#FFFFFF',
      bgcolor: '#FFFFFF',
    };

    let officialPrice = official_price;

    let canChooseTxt = '';
    if (+goods_color_num > 1) {
      canChooseTxt = `${goods_color_num}色可选`;
    } else if (+model_count > 1) {
      canChooseTxt = `${model_count}型可选`;
    }

    let rx = '';
    if (sales_info_text && sales_info_text.length > 0) {
      rx = sales_info_text;
    }
    if (sales_info_num && sales_info_num.length > 0) {
      rx += sales_info_num;
    }

    const isIOS = /ios|iphone|ipad/i.test(navigator.userAgent);

    let sku_type = -1;
    if (
      formatN &&
      parseInt(formatN) == 3 &&
      style_img_list &&
      style_img_list.length > 0
    ) {
      const { formatNType = 0 } = style_img_list[0];
      if (formatNType == 2) {
        sku_type = 2;
      } else if (formatNType == 3) {
        sku_type = 3;
      } else {
        sku_type = 1;
      }
    } else if (
      formatN &&
      parseInt(formatN) == 5 &&
      style_img_list &&
      style_img_list.length > 0
    ) {
      sku_type = 5;
    }

    let bottomTagList = [];
    let totalWidth = 0;

    if (labels && labels.length > 0) {
      for (let i = 0; i < labels.length; i++) {
        const item = labels[i];
        let activityImageWidth = 0.0;
        if (item.type == 'ACTIVITY') {
          if (item.activity_img && item.activity_img.length > 0) {
            if (
              item.activity_img_ratio &&
              parseFloat(item.activity_img_ratio) > 0
            ) {
              activityImageWidth = baseStyle.bottomTagsHeight * parseFloat(item.activity_img_ratio);
            }
          }
        }
        totalWidth += px2dp(8) + (getByteCount(item.text) * px2dp(10) + px2dp(8)) + activityImageWidth;
        if (totalWidth <= baseStyle.bottomTagsWidth) {
          bottomTagList.push(item);
        }
      }
    }

    let wordsData = {};
    const vDatas0 = v_datas && v_datas != null && v_datas.length > 0 ? v_datas[0] : {};
    let item_datas = vDatas0.item_datas && vDatas0.item_datas != null && vDatas0.item_datas.length > 0 ? vDatas0.item_datas : [];
    if (v_datas && v_datas != null && v_datas.length > 0) {
        if (item_datas && item_datas != null && item_datas.length > 0) {
            wordsData = item_datas[0];
        }
    }

    const imgHeight = getImgHeight(dataSource, this.cardWidth);
    const containerHeight = getContainerHeight(dataSource, this.cardWidth);

    let desc = calculateWords(name, spec_name);
    const nameLength = getByteCount(desc);
    const sh_scale_factor = innerWidth / 375
    let descWordNum = Math.floor(21 * sh_scale_factor);
    if (activity_icon && activity_icon.length > 0) {
      descWordNum = descWordNum - Math.ceil(aiDp(14) * activity_ratio / aiDp(13));
    }

    // 文字上间距是否置空
    let nameTopHasData = false;

    if (sku_type == 2 || sku_type == 3 || sku_type == 1 || sku_type == 5) {
      // 一拖三
      nameTopHasData = true;
    } else if (whiteBgImgFlag == false) {
      // 黑底图
      nameTopHasData = true;
    }
    // 文字顶部间距
    // const nameMarginTop = nameTopHasData ? baseStyle.nameMarginTop : 0;
    const nameMarginTop = baseStyle.nameMarginTop
    // 图片背景图高度
    let imageBottomH = parseInt(cateType) == 3 && parseInt(whiteBgImgFlag) == 1 ? baseStyle.imgMarginTop : 0;

    const priceFamliy = shihuo.useNewPriceFontFamily ? shihuo.priceMediumFontFamily : 'PingFangSC-Medium'
    const numberFamliy = 'SHIHUOSans-Medium'

    const onlyOneLine = nameLength <= descWordNum || !nameLineBreak
    const hasActivityIcon = activity_icon.length > 0
    const useTrickPadding = onlyOneLine
    const textPaddingRight = useTrickPadding ? (isIOS ? px2dpSmall(12) : 0) : 0

    return (
      <Fragment>
        <div
          ref={ele => {
            if (ele) {
              this.props.exp && this.props.exp(ele);
            }
          }}
          data-dot={JSON.stringify(h5_exposure_object)}
          className='goods-card'
          style={{
            ...styles.goodsCard,
            height: containerHeight,
            width: this.cardWidth
          }}
          onClick={onPress}
        >
          <div
            className='goods-card-image-body'
            style={{
              ...styles.goodsCardImageBody,
              height: imgHeight / 2
            }}
          >
            {/* 图片灰色蒙版 */}
            <div style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
              backgroundColor: '#00000005',
              borderRadius: px2dp(12),
              zIndex: 9,
            }}></div>
            {/* 商品图片 */}
            <GoodsImage
              ref={ref => (this.goodsImgRef = ref)}
              styles={styles}
              img={img}
              goodsImgFadeDuration={goodsImgFadeDuration}
              beltImg={beltImg}
              beltFrameImg={beltFrameImg}
              imgHeight={imgHeight}
              cardWidth={this.cardWidth}
              isBlackBgImg={isBlackBgImg}
              whiteBgImgFlag={whiteBgImgFlag}
              cateType={cateType}
              img_w={img_w}
              img_h={img_h}
            />
            {actCornerImg ? (
              <img
                className='act-img'
                style={styles.actImg}
                src={shortImageSize(actCornerImg, 64)}
                alt="act"
              />
            ) : null}
            {canChooseTxt ? (
              <div
                className='image-tag'
                style={styles.goodsCardImageTag}
              >
                <img
                  className='image-tag-icon'
                  style={styles.goodsCardImageTagIcon}
                  src="http://static.shihuocdn.cn/admin/files/20200914/102d10c19b6f6a6da07aab18460e0d9d.png"
                  alt="multi"
                />
                <span
                  className='goods-card-image-tag-text'
                  style={styles.goodsCardImageTagText}
                >
                  {canChooseTxt}
                </span>
              </div>
            ) : null}
          </div>

          {sku_type == 1 ? (
            <GoodsStyle3Image
              ref={ref => (this.goodsStyleImgRef = ref)}
              styles={styles}
              cardWidth={this.cardWidth}
              showingStyleList={style_img_list}
              onStyleItemPress={onStyleItemPress}
            />
          ) : sku_type == 5 ? (
            <GoodsStyleImage
              ref={ref => (this.goodsStyleImgRef = ref)}
              styles={styles}
              cardWidth={this.cardWidth}
              showingStyleImgs={style_img_list}
              onStyleItemPress={onStyleItemPress}
            />
          ) : sku_type == 2 ? (
            <GoodsStyle3View 
              styles={styles}
              cardWidth={this.cardWidth}
              showingStyleImgs={style_img_list}
              onStyleItemPress={onStyleItemPress}
            />
          ) : sku_type == 3 ? (
            <GoodsStyle3ImageView
              ref={ref => (this.goodsStyleImgRef = ref)}
              styles={styles}
              cardWidth={this.cardWidth}
              showingStyleImgs={style_img_list}
              onStyleItemPress={onStyleItemPress}
            />
          ) : null}
          <div
            style={{
              width: '100%',
              paddingLeft: px2dp(8),
              paddingRight: px2dp(8),
              display: 'flex',
              flexDirection: 'row',
              boxSizing: 'border-box',
            }}
          >
            <p
              className='goods-name'
              style={{
                ...styles.name,
                marginTop: nameMarginTop,
                // paddingRight: textPaddingRight,
                boxSizing: 'border-box',
                fontSize: px2dp(28),
                height: onlyOneLine ? aiDp(20) : aiDp(40),
                lineHeight: '20px',
                overflow: 'hidden',
                wordBreak: 'break-all',
                textAlign: 'left',
              }}
            >
              {hasActivityIcon ? (
                <span
                  style={{
                    display: 'inline-block',
                    width: aiDp(14) * activity_ratio + aiDp(4),
                    height: aiDp(14),
                    position: 'relative',
                    top: aiDp(2)
                  }}
                >
                  <img
                    src={shortImageSize(activity_icon)}
                    alt="promo"
                    style={{ width: aiDp(14) * activity_ratio, height: aiDp(14) }}
                  />
                </span>
              ) : null}
              {onlyOneLine ? (useTrickPadding ? desc : handleName(desc, descWordNum)) : desc}
            </p>
          </div>

          {bottomTagList && bottomTagList.length > 0 ? (
            <div
              style={styles.bottomTags}
            >
              {bottomTagList.map((tag, index) => {
                if (tag.type == 'ACTIVITY') {
                  const hasTagImg = tag.activity_img && tag.activity_img.length > 0;
                  return (
                    <div
                      key={index}
                      style={{
                        ...styles.bottomTagActivityNormal,
                        backgroundColor: tag.bgcolor,
                        borderColor: tag.bcolor,
                        marginLeft: index == 0 ? 0 : px2dp(8)
                      }}
                    >
                      {
                        tag.activity_img && tag.activity_img.length > 0 ? (
                          <img
                            key={index + 'ACTIVITY'}
                            src={
                              tag.activity_img.indexOf('http') != -1
                                ? tag.activity_img
                                : 'http://static.shihuocdn.cn/admin/files/20210823/05e993be26fe39e149f1cccc7492c271.png'
                            }
                            alt="activity"
                            style={{
                              ...styles.bottomTagActivityImg,
                              width: parseFloat(tag.activity_img_ratio) * baseStyle.bottomTagsHeight,
                            }}
                          />
                        ) : null
                      }
                      <div
                        style={{
                          ...(hasTagImg ? styles.bottomTagActivityTxtContainer : styles.bottomTagActivityNorTxtContainer),
                          borderColor: tag.bcolor || '#ffffff',
                        }}
                      >
                        <p
                          style={{
                            ...styles.bottomTagActivityTxt,
                            color: tag.tcolor
                          }}
                        >
                          {tag.text}
                        </p>
                      </div>
                    </div>
                  )
                } else if (tag.routineImg && tag.routineImg.length > 0) {
                  const imgW = aiDp(14) * tag.routineRatio;
                  return (
                    <div
                      style={{
                        ...styles.fanBGView,
                        marginLeft: index == 0 ? 0 : px2dp(8)
                      }}
                    >
                      <div
                        style={{
                          ...styles.fanContentView,
                          borderColor: tag.bcolor || '#ffffff'
                        }}
                      >
                        {
                          tag.routineImg ? 
                            <img
                              style={{
                                ...styles.fanIconView,
                                width: imgW
                              }}
                              src={tag.routineImg}
                            /> : null
                        }
                        <div style={styles.fanTxtBGView}>
                          <p
                            style={{
                              ...styles.fanTxt,
                              color: tag.tcolor || '#ff4338'
                            }}
                          >
                            {tag.text}
                          </p>
                        </div>
                      </div>
                    </div>
                  )
                } else if (tag.bgcolor && tag.bgcolor.indexOf('http') != -1) {
                  return (
                    <div
                      key={index + 'NEW_GOODS'}
                      style={{
                        ...styles.bottomTagNormal,
                        borderRadius: 0,
                        borderWidth: 0,
                        backgroundColor: tag.bgcolor || '#ffffff',
                        borderColor: tag.bcolor || '#ffffff',
                        marginLeft: index == 0 ? 0 : px2dp(8),
                        backgroundImage: `url(${tag.bgcolor.indexOf('http') != -1 ? tag.bgcolor : 'http://static.shihuocdn.cn/admin/files/20210823/05e993be26fe39e149f1cccc7492c271.png'})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                      }}
                    >
                      <p
                        style={{
                          ...styles.bottomTagNormalTxt,
                          color: tag.tcolor || '#333333',
                        }}
                      >
                        {tag.text}
                      </p>
                    </div>
                  );
                } else {
                  return (
                    <div
                        key={index}
                        style={{
                          ...styles.bottomTagNormal,
                          backgroundColor: tag.bgcolor,
                          borderColor: tag.bcolor,
                          marginLeft: index == 0 ? 0 : px2dp(8)
                        }}
                    >
                        <p
                          style={{
                            ...styles.bottomTagNormalTxt,
                            color: tag.tcolor,
                          }}
                        >
                          {tag.text}
                        </p>
                    </div>
                  );
                }
              })}
            </div>
          ) : v_datas && v_datas != null && v_datas.length > 0 ? (
            <div style={styles.bottomWords}>
              {v_datas.map((item, index) =>
                this._renderRecommendView(item, v_datas.length, index)
              )}
            </div>
          ) : null}

          <div
            ref={ref => this.bottomRef = ref}
            style={styles.bottom}
          >
            <div
              ref={ref => this.priceViewRef = ref}
              className='price-view-wrap'
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <SHCardPriceView
                isDark={isDark}
                price={price}
                mainPriceStyle={{ fontFamily: numberFamliy }}
                symbolStyle={{ fontFamily: numberFamliy }}
                dotPriceStyle={{ fontFamily: numberFamliy }}
                unitPirceStyle={{ fontFamily: priceFamliy }}
              />
            </div>
            {/* 附加信息 */}
            {(() => {
                const { priceViewWidth = 0, infoViewWidth = 0, hotViewWidth = 0, parentWidth = 0 } = this.state || {};
                let showInfo = false;
                let showHot = false;
                if (priceViewWidth + infoViewWidth + hotViewWidth < parentWidth) {
                    showInfo = true;
                    showHot = true;
                } else if (priceViewWidth + hotViewWidth < parentWidth) {
                    showHot = true;
                }
                return (
                  <Fragment>
                    {showInfo && (
                      <div
                        ref={ref => this.infoViewRef = ref}
                        className='info-view'
                        style={{
                          marginTop: aiDp(2),
                          display: 'flex',
                          flexDirection: 'row',
                          marginLeft: aiDp(2)
                        }}
                      >
                        {price_datas.map((item, index) => {
                          return this._renderNormalTexts(item, price_datas.length, index)
                        })}
                      </div>
                    )}
                    {showHot && (
                      <p
                        ref={ref => this.hotViewRef = ref}
                        className='hot-view'
                        style={{
                          ...styles.hot,
                          marginLeft: aiDp(2),
                          fontSize: fontSizeExp ? aiDp(11) : aiDp(12),
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          lineClamp: 1
                        }}
                      >
                        {rx}
                      </p>
                    )}
                  </Fragment>
                );
            })()}
          </div>
        </div>
      </Fragment>
    );
  }

  _renderRecommendView = (data, count, index) => {
    const { dsl = '' } = data;
    switch (dsl) {
      case 'HOT_LIST':
        return this._renderHostList(data, count, index);
      case 'NORMAL_TEXT':
        return this._renderNormalText(data, count, index);
      case 'NORMAL_TEXT_ONE':
        return this._renderNormalText(data, count, index);
      default:
        return null;
    }
  };

  _renderHostList = (data, count, index, isDark) => {
    const {
      href = '',
      borderColor = '#FFFFFF',
      backgroundColor = '#FFFFFF',
      borderColor_dark = '#242424',
      backgroundColor_dark = '#242424',
      item_datas = [],
    } = data;

    let firstItem = {};
    let secondItem = {};
    let thirdItem = {};
    if (item_datas && item_datas.length >= 3) {
      firstItem = item_datas[0] || {};
      secondItem = item_datas[1] || {};
      thirdItem = item_datas[2] || {};
    }

    const textStyle = index === 0 ? { maxWidth: 125 } : {};

    const containerStyle = {
      height: '100%',
      borderRadius: 2,
      border: `1px solid ${isDark ? borderColor_dark : borderColor}`,
      backgroundColor: isDark ? backgroundColor_dark : backgroundColor,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: index > 0 ? 4 : 0,
      padding: '0 4px',
      boxSizing: 'border-box',
      overflow: 'hidden',
      cursor: href ? 'pointer' : 'default',
      boxSizing: 'border-box',
    };

    const handleClick = () => {
      if (href) {
        window.location.href = href;
      }
    };

    return (
      <div key={`hot_${index}`} style={containerStyle} onClick={handleClick}>
        {firstItem.img ? (
          <img
            style={{ width: 12, height: 14, marginRight: 2 }}
            src={firstItem.img}
            alt="hot-left"
          />
        ) : null}
        <span
          style={{
            marginLeft: 2,
            color: isDark
              ? firstItem.textColor_dark || '#666666'
              : firstItem.textColor || '#666666',
            fontSize: secondItem.fontSize || 11,
            fontFamily: 'PingFangSC-Regular',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            ...textStyle,
          }}
        >
          {secondItem.text || ''}
        </span>
        {thirdItem.img ? (
          <img
            style={{ marginLeft: 4, width: 6, height: 14 }}
            src={thirdItem.img}
            alt="hot-right"
          />
        ) : null}
      </div>
    );
  };

  _renderNormalText = (data, count, index, isDark) => {
    const {
      borderColor = '#FFFFFF',
      backgroundColor = '#FFFFFF',
      borderColor_dark = '#242424',
      backgroundColor_dark = '#242424',
      item_datas = [],
    } = data;

    let firstItem = {};
    if (item_datas && item_datas.length >= 1) {
      firstItem = item_datas[0] || {};
    }
    const {
      textColor = '#666666',
      textColor_dark = '#666666',
      fontSize = 11,
      text = '',
    } = firstItem;

    const spanStyle = {
      marginLeft: index > 0 ? 4 : 0,
      color: isDark ? textColor_dark : textColor,
      fontSize,
      fontFamily: 'PingFangSC-Regular',
      backgroundColor: isDark ? backgroundColor_dark : backgroundColor,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };

    return (
      <span key={`normal_${index}`} style={spanStyle}>
        {text}
      </span>
    );
  };

  _renderNormalTexts = (data, count, index, fontSizeExp) => {
    const { item_datas = [], backgroundColor = '#FFFFFF' } = data;
    let firstItem = {};
    if (item_datas && item_datas.length >= 1) {
      firstItem = item_datas[0] || {};
    }
    const { textColor = '#666666', fontSize = 11, text = '' } = firstItem;
    const textFontSize = fontSizeExp ? 11 : 12;

    const spanStyle = {
      marginLeft: index > 0 ? 4 : 0,
      color: textColor,
      fontSize: textFontSize,
      fontFamily: 'PingFangSC-Regular',
      backgroundColor,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };

    return (
      <span key={`normal_extra_${index}`} style={spanStyle}>
        {text}
      </span>
    );
  };
}

const pageStyles = {
  goodsCard: {
    overflow: 'hidden',
    marginBottom: baseStyle.containerMarginTop,
    backgroundColor: DynamicColorValue.dyc_ffffff_fg,
    borderRadius: px2dp(12),
  },
  goodsCardImageBody: {
    position: 'relative',
    width: '100%',
    borderRadius: px2dp(12),
    overflow: 'hidden',
    backgroundColor: '#ffffff',
  },
  goodsCardImageTag: {
    position: 'absolute',
    top: px2dp(16),
    right: px2dp(16),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: px2dp(1),
    borderColor: '#DEDEDE',
    borderRadius: px2dp(17),
    paddingVertical: px2dp(2),
    paddingHorizontal: px2dp(8),
    backgroundColor: 'rgba(255,255,255,0.8)',
    boxSizing: 'border-box',
  },
  goodsCardImageTagText: {
    fontSize: px2dp(20),
    color: DynamicColorValue.dyc_333333,
    fontFamily: 'PingFangSC-Regular',
  },
  ratio5_4Img: {
    position: 'absolute',
    width: '100%',
    top: px2dp(16),
    bottom: -px2dp(16),
  },
  blackImg: {
    width: '100%',
    height: '100%',
    marginTop: 0,
    marginHorizontal: 0,
  },
  img: {
    width: '100%',
    height: '100%',
    // marginTop: px2dp(20),
    marginHorizontal: px2dp(10),
    flex: 1,
  },
  goodsCardSku: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    marginTop: px2dp(8),
    paddingHorizontal: px2dp(14),
    width: '100%',
    height: px2dp(56),
    boxSizing: 'border-box',
  },
  goodsCardSku3: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    marginTop: px2dp(8),
    paddingHorizontal: aiDp(4),
    width: '100%',
    height: px2dp(88),
    boxSizing: 'border-box',
  },
  goodsCardSku3View: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    marginTop: px2dp(8),
    paddingHorizontal: aiDp(4),
    width: '100%',
    height: px2dp(90),
    boxSizing: 'border-box',
  },
  goodsCardSku3ImgTextView: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    marginTop: px2dp(8),
    paddingHorizontal: aiDp(4),
    width: '100%',
    height: px2dp(88),
    boxSizing: 'border-box',
  },
  goodsCardSkuBorder: {
    overflow: 'hidden',
    width: px2dp(56),
    height: px2dp(56),
    borderColor: '#F1F1F1',
    borderWidth: px2dp(1),
    borderRadius: px2dp(4),
  },
  goodsCardSkuImage: {
    width: px2dp(56),
    height: px2dp(56),
  },
  goodsCardSkuBorder3: {
    overflow: 'hidden',
    width: px2dp(88),
    height: px2dp(88),
    borderColor: '#F1F1F1',
    borderWidth: px2dp(1),
    borderRadius: px2dp(4),
  },
  goodsCardSkuBorderV3: {
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    width: px2dp(88),
    height: px2dp(90),
    borderColor: '#F1F1F1',
    borderWidth: px2dp(1),
    borderRadius: px2dp(4),
  },
  goodsCardSkuImage3: {
    width: px2dp(88),
    height: px2dp(88),
  },

  goodsCardSkuLogoImage: {
    width: aiDp(4),
    height: aiDp(4),
    position: 'absolute',
    left: -1,
    top: -1,
  },
  goodsCardSkuColor: {
    display: 'flex',
    justifyContent: 'center',
    width: px2dp(48),
    height: px2dp(48),
    marginTop: px2dp(10),
    borderRadius: aiDp(4),
    overflow: 'hidden',
  },
  goodsCardSkuImgT: {
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
  },
  goodsCardSkuImgText: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: px2dp(22),
    backgroundColor: 'rgba(255,255,255,0.85)',
    paddingHorizontal: px2dp(4),
    display: 'flex',
    justifyContent: 'center',
    color: '#333333',
    fontFamily: 'PingFangSC-Regular',
    fontSize: px2dp(16),
    // lineHeight: px2dp(22),
    color: '#333333',
    textAlign: 'center',
    boxSizing: 'border-box',
  },
  goodsCardSkuText: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: px2dp(5),
    color: '#333333',
    fontFamily: 'PingFangSC-Regular',
    fontSize: px2dp(16),
    // lineHeight: px2dp(22),
    width: px2dp(80),
    color: '#333333',
    textAlign: 'center',
  },
  goodsCardInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: px2dp(16),
    paddingHorizontal: aiDp(4),
    boxSizing: 'border-box',
  },
  goodsCardTop: {
    display: 'flex',
    justifyContent: 'space-between',
    height: px2dp(72),
  },
  name: {
    fontSize: px2dp(26),
    fontFamily:
      isAndroid ? 'PingFangSC-Regular' : 'PingFangSC-Medium',
    color: DynamicColorValue.dyc_333333,
    // lineHeight: px2dp(40),
    marginTop: baseStyle.nameMarginTop,
  },
  goodsCardBottom: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: px2dp(8),
  },
  goodsCardBottomLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  goodsCardTag: {
    position: 'relative',
    top: px2dp(5),
    borderRadius: px2dp(2),
    borderWidth: px2dp(1),
    borderColor: DynamicColorValue.dyc_333333,
    marginLeft: px2dp(12),
    paddingHorizontal: px2dp(4),
    boxSizing: 'border-box',
  },
  goodsCardImageTagIcon: {
    marginRight: px2dp(8),
    width: px2dp(20),
    height: px2dp(20),
  },
  goodsCardTagText: {
    fontSize: px2dp(20),
    color: DynamicColorValue.dyc_333333,
    fontFamily: 'PingFangSC-Regular',
  },
  goodsCardSymbol: {
    position: 'relative',
    top: px2dp(8),
    fontSize: aiDp(4),
    color: DynamicColorValue.dyc_333333,
    fontFamily: 'PingFangSC-Regular',
  },
  goodsCardNum: {
    position: 'relative',
    top: px2dp(4),
    //fontFamily: 'HelveticaNeue-CondensedBold',
    fontSize: px2dp(36),
    color: DynamicColorValue.dyc_333333,
    fontFamily: 'PingFangSC-Regular',
  },
  goodsCardOriginalPrice: {
    position: 'relative',
    top: px2dp(6),
    fontSize: px2dp(26),
    color: DynamicColorValue.dyc_999999,
    marginLeft: px2dp(12),
    textDecorationLine: 'line-through',
    fontFamily: 'PingFangSC-Regular',
  },
  goodsCardAmount: {
    position: 'relative',
    bottom: -px2dp(4),
    marginLeft: px2dp(14),
    fontFamily: 'PingFangSC-Light',
    fontSize: px2dp(22),
    color: DynamicColorValue.dyc_999999,
  },
  bottomWords: {
    marginLeft: aiDp(4),
    marginRight: aiDp(4),
    marginTop: aiDp(1),
    height: baseStyle.bottomWordsHeight,
    lineHeight: `${baseStyle.bottomWordsHeight}px`,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    overflow: 'hidden',
    marginHorizontal: aiDp(4),
  },
  vDataItemsView: {
    paddingHorizontal: aiDp(4),
    marginTop: 0,
    height: baseStyle.bottomWordsHeight,
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  vDataLeftImg: {
    marginRight: px2dp(2),
    marginBottom: px2dp(2),
    width: aiDp(4),
    height: px2dp(26),
  },
  vDataLeftHead: {
    width: px2dp(28),
    height: px2dp(28),
    borderRadius: px2dp(14),
    overflow: 'hidden',
  },
  vDataText: {
    fontSize: px2dp(22),
    fontFamily: 'PingFangSC-Regular',
    // lineHeight: px2dp(28),
    height: px2dp(28),
    maxWidth: px2dp(255),
    paddingTop: px2dp(1),
    boxSizing: 'border-box',
  },
  vDataCommentContainer: {
    paddingLeft: px2dp(8),
    fontSize: px2dp(22),
    fontFamily: 'PingFangSC-Regular',
    // lineHeight: px2dp(28),
    height: px2dp(28),
    maxWidth: px2dp(250),
    overflow: 'hidden',
    paddingTop: px2dp(2),
    boxSizing: 'border-box',
  },
  vDataComment: {
    fontSize: px2dp(22),
    fontFamily: 'PingFangSC-Regular',
    // lineHeight: px2dp(28),
    height: px2dp(28),
    paddingTop: px2dp(2),
    boxSizing: 'border-box',
  },
  vDataYinHao: {
    fontSize: px2dp(22),
    fontFamily: 'PingFangSC-Regular',
    // lineHeight: px2dp(28),
    minWidth: px2dp(18),
    height: px2dp(28),
    paddingTop: px2dp(2),
    boxSizing: 'border-box',
  },

  vDataRightImg: {
    width: px2dp(12),
    height: px2dp(28),
    marginLeft: px2dp(8),
    paddingBottom: 0,
    marginBottom: 0,
  },
  bottomTags: {
    marginTop: aiDp(1),
    marginLeft: aiDp(4),
    marginRight: aiDp(4),
    height: baseStyle.bottomWordsHeight,
    display: 'flex',
    flexDirection: 'row',
    width: baseStyle.bottomTagsWidth,
    alignItems: 'center',
  },
  bottomTagActivityNormal: {
    borderRadius: px2dp(4),
    marginLeft: px2dp(8),
    height: baseStyle.bottomTagsHeight,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    backgroundColor: DynamicColorValue.dyc_ff4338,
    overflow: 'hidden',
  },
  bottomTagActivityImg: {
    height: baseStyle.bottomTagsHeight,
    marginHorizontal: 0,
    marginLeft: 0,
  },
  bottomTagActivityTxtContainer: {
    borderTopRightRadius: px2dp(4),
    borderBottomRightRadius: px2dp(4),
    borderWidth: px2dp(1),
    height: baseStyle.bottomTagsHeight,
    borderLeftColor: DynamicColorValue.dyc_ffffff_fg,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomTagActivityNorTxtContainer: {
    borderRadius: px2dp(4),
    borderWidth: px2dp(1),
    height: baseStyle.bottomTagsHeight,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomTagActivityTxt: {
    fontSize: px2dp(20),
    color: '#ffffff',
    fontFamily: 'PingFangSC-Regular',
    height: baseStyle.bottomTagsHeight,
    // lineHeight: baseStyle.bottomTagsHeight,
    maxWidth: baseStyle.bottomTagsWidth,
    marginHorizontal: px2dp(4),
  },

  bottomTagNormal: {
    borderRadius: px2dp(4),
    borderWidth: px2dp(1),
    borderColor: DynamicColorValue.dyc_ff4338,
    marginLeft: px2dp(8),
    paddingHorizontal: px2dp(4),
    height: baseStyle.bottomTagsHeight,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: DynamicColorValue.dyc_ff4338,
    boxSizing: 'border-box',
  },
  bottomTagNormalTxt: {
    fontSize: px2dp(20),
    color: '#ffffff',
    fontFamily: 'PingFangSC-Regular',
    // lineHeight: baseStyle.bottomTagsHeight,
    height: baseStyle.bottomTagsHeight,
    paddingBottom: isAndroid ? px2dp(1) : 0,
    maxWidth: baseStyle.bottomTagsWidth,
    boxSizing: 'border-box',
  },
  cave: {
    width: px2dp(10),
    marginHorizontal: px2dp(1),
    height: baseStyle.bottomTagsHeight,
    overflow: 'hidden',
  },
  caveCircle: {
    position: 'absolute',
    left: 0,
    borderRadius: px2dp(5),
    width: px2dp(10),
    borderWidth: px2dp(1),
    height: px2dp(10),
    backgroundColor: '#ffffff',
  },
  caveDotLine: {
    marginTop: px2dp(5),
    marginLeft: px2dp(4),
    width: px2dp(2),
    height: px2dp(18),
  },
  caveDot: {
    width: px2dp(2),
    height: px2dp(2),
  },
  bottomTagsRankContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: baseStyle.bottomTagsHeight,
    marginBottom: baseStyle.bottomTagsRankMarginBottom,
  },
  bottom: {
    height: px2dp(50),
    marginLeft: aiDp(4),
    marginRight: px2dp(20),
    marginTop: isAndroid ? 0 : aiDp(2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  priceSymbol: {
    fontSize: aiDp(4),
    fontFamily: 'PingFangSC-Medium',
    color: DynamicColorValue.dyc_333333,
    paddingRight: 0,
  },
  priceSymbolIOS: {
    paddingTop: px2dp(8),
    boxSizing: 'border-box',
  },
  priceStyle: {
    fontFamily: 'PingFangSC-Medium',
  },
  price: {
    fontSize: px2dp(36),
    fontFamily: 'PingFangSC-Medium',
    color: DynamicColorValue.dyc_333333,
    // lineHeight: px2dp(42),
  },
  priceIOS: {
    // lineHeight: px2dp(40),
  },
  tag: {
    marginLeft: px2dp(4),
    height: px2dp(28),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#ffffff',
  },
  tagTxt: {
    fontSize: px2dp(22),
    color: '#999999',
    fontFamily: 'PingFangSC-Regular',
    // lineHeight: px2dp(27),
  },
  officialPrice: {
    marginLeft: px2dp(6),
    fontSize: px2dp(22),
    color: '#999999',
    fontFamily: 'PingFangSC-Regular',
    textDecorationLine: 'line-through',
    // lineHeight: px2dp(26),
    position: 'absolute',
    top: px2dp(4),
  },
  hotContainer: {
    marginLeft: px2dp(4),
  },
  hot: {
    marginTop: px2dp(6),
    color: '#666666',
    fontFamily: 'PingFangSC-Regular',
    textAlign: 'right',
    // lineHeight: px2dp(32),
  },
  hotIOS: {
    // lineHeight: px2dp(39),
    paddingTop: -px2dp(2),
    boxSizing: 'border-box',
  },
  actImg: {
    position: 'absolute',
    left: px2dp(10),
    top: px2dp(10),
    width: px2dp(64),
    height: px2dp(40),
  },
  beltImg: {
    position: 'absolute',
    left: -px2dp(5),
    bottom: 0,
    width: '100%',
    aspectRatio: 171 / 42,
  },
  blackBeltImg: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    aspectRatio: 171 / 42,
  },
  beltFrameImg: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    aspectRatio: 1 / 1.333,
  },
  fanBGView: {
    display: 'flex',
    flexDirection: 'row',
    width: baseStyle.bottomTagsWidth,
  },
  fanContentView: {
    display: 'flex',
    flexDirection: 'row',
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: pxdp(2),
    borderColor: '#FFB4B3',
    backgroundColor: 'transparent',
    overflow: 'hidden',
  },
  fanIconView: {
    width: pxdp(33),
    height: pxdp(14),
  },
  fanTxtBGView: {
    height: pxdp(14),
    paddingLeft: pxdp(2),
    paddingRight: pxdp(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  fanTxt: {
    color: '#FF4338',
    fontFamily: 'PingFangSC-Regular',
    fontSize: pxdp(11),
  },
  imageCover: {
    width: '100%',
    height: '100%',
    backgroundColor: 'red',
  },
};

export default {
  widget: SHGoodsCommonVertFlatStyle8Widget,
  getWidgetHeight,
  showStyleList: false,
  getTags,
};



// WEBPACK FOOTER //
// ./components/pipeline-goodsRecommend/lib/SHCard/widgets/SHGoodsCommonVertFlatStyle8Widget.js